
<modal :state="state" :index="index" @toggle-modal="emitHideModal">
  <div slot="body">
    <h3 class="modal-title">{{details.confirmationHeader}}</h3>
    <p v-if="details.htmlSafeConfirmationMessage" v-html="details.htmlSafeConfirmationMessage"></p>

    <div v-if="noteRequired" class="align-left mt-3 new-comms-area">
      <label for="required-note" class="required ">Please include a note to explain this action.</label>
      <note-editor
        refs="note-editor"
        v-model="newNote.text"
        id="required-note"
        placeholder="Write your note here..."
      ></note-editor>
    </div>

    <div class="cta">
      <button v-if="details.showCancel" type="button" @click="emitHideModal" :class="buttonClass('cancel')" data-action="cancel">{{details.cancelText}}</button>
      <button v-if="details.showAffirm"
              type="button"
              @click="affirmAction"
              :class="buttonClass('affirm')"
              :disabled="disableAffirm"
              data-action="affirm">
        {{ details.affirmText }}
      </button>
    </div>
  </div>
</modal>
